import React, { Fragment } from "react"
import PropTypes from "prop-types"

import { TreeSelect, Select, Popover, Radio, Divider } from "antd"

import "./index.less"
import { LockIcon } from "../../../../icons/svg/iconLock"
import { filter, find, get, map } from "lodash"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { isModuleBySlug } from "../../../../utils/storage"
import { QUESTION_PONDERATED } from "../../../../utils/constants"
import { verifyFeatureFlag } from "../../../../utils/feature-flags"

const { TreeNode } = TreeSelect

export function LikertForm(props) {
  const isQuestionPonderated = isModuleBySlug(QUESTION_PONDERATED)
  const featureFlagSegment = verifyFeatureFlag('seg2-5')

  const renderDimensionOrOutcome = () => {
    const { engagementCheck, isCreate } = props
    return (
      <div className="DimensionOrOutcome">
        <div className="DimensionOrOutcome__Header">
          <div className="DimensionOrOutcome__Header--title">
            {engagementCheck ? "Outcome" : "Dimensión"}
          </div>
          <div className="DimensionOrOutcome__Header--lock">
            {!isCreate && <LockIcon />}
          </div>
        </div>
        <div className="DimensionOrOutcome__Content">
          {renderSelectDimensionOrOutcome()}
        </div>
      </div>
    )
  }

  const renderSelectDimensionOrOutcome = () => {
    const {
      dimensions,
      dimensionList,
      onChangeDimension,
      engagementCheck,
      disabledFields,
      onChangeOutcome,
    } = props
    const dimensionsWithoutEngagement = filter(
      [...dimensionList],
      ({ data }) => data.name.toLowerCase() !== "engagement"
    )
    const dimensionsWithEngagement =
      find(
        [...dimensionList],
        ({ data }) => data.name.toLowerCase() === "engagement"
      ) || []
    if (engagementCheck) {
      return (
        <Select
          style={{ width: "60%" }}
          disabled={disabledFields}
          value={dimensions}
          placeholder="Seleccionar outcome"
          onChange={(valueChange) => {
            onChangeOutcome(valueChange)
          }}>
          {map(get(dimensionsWithEngagement, "children", []), ({ data }) => {
            return (
              <Select.Option
                name="opcionOutcome"
                key={data.id_dimension_has_survey}
                value={data.id_dimension_has_survey}>
                {data.name}
              </Select.Option>
            )
          })}
        </Select>
      )
    }
    return (
      <TreeSelect
        disabled={disabledFields}
        value={dimensions}
        style={{ width: 314 }}
        dropdownStyle={{ maxHeight: 320, overflow: "auto" }}
        placeholder="Seleccionar dimensión"
        showSearch
        treeDefaultExpandAll
        className="selector-dimension-multiple"
        onChange={(valueChange) => {
          onChangeDimension(valueChange)
        }}>
        {renderNodesTreeSelect(dimensionsWithoutEngagement)}
      </TreeSelect>
    )
  }

  const renderNodesTreeSelect = (dimensionsWithoutEngagement) =>
    map(dimensionsWithoutEngagement, ({ data, children }) => {
      return (
        <TreeNode
          value={data.id_dimension_has_survey}
          key={data.id_dimension_has_survey}
          title={data.name}>
          {map(children, (child) => {
            return (
              <TreeNode
                key={child.data.id_dimension_has_survey}
                value={child.data.id_dimension_has_survey}
                title={child.data.name}
              />
            )
          })}
        </TreeNode>
      )
    })

    //TODO: delete this
    // this function its not necesary because the component was moved
    // to the QuestionDrawer component
  const renderPonderated = () => {
    const {
      onChangePonderated,
      ponderated,
      engagementCheck,
      surveyData,
    } = props
    if (engagementCheck) {
      return null
    }
    const options = [
      { label: "0", value: "0" },
      { label: "1", value: "1" },
    ]
    return (
      <Fragment>
        <Divider style={{ margin: "16px 0" }} />
        <div className="Ponderated">
          <div className="Ponderated__Header">
            <strong className="Ponderated__Header--title">Ponderador</strong>
            {renderPopoverPonderated()}
          </div>
          <div className="Ponderated__RadioButton">
            <Radio.Group
              disabled={surveyData.measures?.length > 0}
              options={options}
              onChange={(e) => onChangePonderated(e.target.value)}
              value={ponderated}
              optionType="button"
            />
          </div>
        </div>
      </Fragment>
    )
  }

  const renderPopoverPonderated = () => {
    return (
      <Popover
        placement="bottomLeft"
        align={{ offset: [-10, 0] }}
        content={
          <div style={{ width: 368, fontSize: 13 }}>
            <span>
              El ponderador determina si la pregunta tendrá un impacto en el
              resultado de la subdimensión/dimensión a la que pertenece
            </span>
            <ul style={{ paddingLeft: 24 }}>
              <li>
                <span style={{ marginLeft: "-4px" }}>
                  Si el ponderador es <strong>1</strong>, la pregunta sí se
                  tomará en cuenta para el cálculo de la subdimensión/dimensión.
                </span>
              </li>
              <li>
                <span style={{ marginLeft: "-4px" }}>
                  Si el ponderador es <strong>0</strong>, aunque la pregunta
                  estará incluida en la encuesta, su resultado{" "}
                  <strong>no</strong> será tomando en consideración para el
                  cálculo de la subdimensión/dimensión.
                </span>
              </li>
            </ul>
          </div>
        }
        overlayClassName="PopoverPonderated">
        <QuestionIcon />
      </Popover>
    )
  }

  return (
    <div className="LikertForm">
      {renderDimensionOrOutcome()}
      { !featureFlagSegment && isQuestionPonderated && renderPonderated()}
    </div>
  )
}

LikertForm.propTypes = {
  isCreate: PropTypes.bool,
  engagementCheck: PropTypes.bool,
  dimensions: PropTypes.number,
  ponderated: PropTypes.string,
  onChangeDimension: PropTypes.func,
  dimensionList: PropTypes.array,
  disabledFields: PropTypes.bool,
  onChangePonderated: PropTypes.func,
  surveyData: PropTypes.object,
}

export default LikertForm
